import { API } from "./config";
import { AxiosResponse } from 'axios';
import { IResumeResponse } from "../Interfaces/IResumeResponse";

export const resumeService = {
  getData: async(year: string, userID: number, token: string): Promise<AxiosResponse<IResumeResponse>> => {
    const data = { year, userID };
    return await API.post(`/resume`, data, { headers: { 'Authorization': `Bearer ${token}`  } });
  },
}